import AWS from 'aws-sdk';

const invokeLambda = (idToken, userPoolId, identityPoolId, functionName, payload, callback) => {
    AWS.config.update({
        region: 'ap-south-1', // your region
        credentials: new AWS.CognitoIdentityCredentials({
            IdentityPoolId: identityPoolId,
            Logins: {
                [`cognito-idp.ap-south-1.amazonaws.com/${userPoolId}`]: idToken
            }
        })
    });

    AWS.config.credentials.refresh(error => {
        if (error) {
            console.error('Credentials refresh error:', error);
            callback(error, null);
        }
        else {
            const lambda = new AWS.Lambda();

            const params = {
                FunctionName: functionName,
                Payload: JSON.stringify(payload)
            };

            lambda.invoke(params, (err, data) => {
                if (err) {
                    console.error('Lambda invoke error:', err);
                    callback(err, null);
                } else {
                    try {
                        const result = JSON.parse(data.Payload);
                        callback(null, result);
                    }
                    catch (parseError) {
                        console.error('Parse error:', parseError);
                        callback(parseError, null);
                    }
                }
            });
        }
    });
};

export default invokeLambda;